<template>
  <div>
    <kst-input field="Date" :data="data" :catalog="Catalog"/>
    <kst-input field="WarehouseName" :data="data" :catalog="Catalog"/>
    <kst-input field="ClosingNumber" :data="data" :catalog="Catalog"/>
    <kst-input field="Comment" :data="data" :catalog="Catalog"/>

    <kst-output control-off field="CreatedBy" :data="data" :catalog="Catalog">
      <template #default>
        <kst-output expanded floating-label
          class="pr-2"
          field="CreatedByID" :data="data" :catalog="Catalog"
        />
      </template>
      <template #right>
        <kst-output addons expanded floating-label
          field="CreatedDate" :data="data" :catalog="Catalog"
        />
      </template>
    </kst-output>
  </div>
</template>

<script>
import SearchMixin from "@/mixins/SearchMixin.js";
import Catalog from "./StockClosingDetailCatalog.js";

export default {
  mixins: [SearchMixin],
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>